export const SUPPORTED_DOCUMENT_TYPES = {
    "ACTIVE_TOPIC_DOCUMENT_TYPE": "activeTopic",
    "STATIC_DOCUMENT_TYPE": "staticDocument",
    "QUESTIONNAIRE_DOCUMENT_TYPE": "questionnaire",
    "ERROR_PATTERN_DOCUMENT_TYPE": "errorPattern",
    "CONDITIONAL_DOCUMENT_TYPE": "conditional",
    "META_DOCUMENT_TYPE": "meta"
}